import { WINDOWS_CDN_PATH } from '../../../windows-constants';

export const REHAU_BRAND_STRUCTURE = {
  title: 'brands-section.rehau-title',
  description: 'brands-section.rehau-description',
  detailedInfo: [
    {
      imgSrc: `${WINDOWS_CDN_PATH}/brands/rehau/blitz.jpg/blitz.jpg`,
      name: 'Blitz',
      mountingWidth: '60 мм',
      numberOfCameras: '3',
      thermalInsulation: '0,77 м² ̊С/Вт',
      doubleGlazing: 'до 32 мм',
    },
    {
      imgSrc: `${WINDOWS_CDN_PATH}/brands/rehau/delight-design.jpg/delight-design.jpg`,
      name: 'DELIGHT-Design',
      mountingWidth: '70 мм',
      numberOfCameras: '5',
      thermalInsulation: '0,94 м² ̊С/Вт',
      doubleGlazing: 'до 40 мм',
    },
    {
      imgSrc: `${WINDOWS_CDN_PATH}/brands/rehau/grazio.jpg/grazio.jpg`,
      name: 'GRAZIO',
      mountingWidth: '70 мм',
      numberOfCameras: '5',
      thermalInsulation: '0,85 м² ̊С/Вт',
      doubleGlazing: 'до 40 мм',
    },
    {
      imgSrc: `${WINDOWS_CDN_PATH}/brands/rehau/intelio.jpg/intelio.jpg`,
      name: 'INTELIO',
      mountingWidth: '80 мм',
      numberOfCameras: '6',
      thermalInsulation: '0,98 м² ̊С/Вт',
      doubleGlazing: 'до 53 мм',
    },
    {
      imgSrc: `${WINDOWS_CDN_PATH}/brands/rehau/constanta.jpg/constanta.jpg`,
      name: 'CONSTANTA',
      mountingWidth: '60 мм',
      numberOfCameras: '4',
      thermalInsulation: '0,78 м² ̊С/Вт',
      doubleGlazing: 'до 40 мм',
    },
  ],
};
